import React from 'react';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Sparkles } from '../../../icons/sparkles';
import STRING_KEYS from '../../../language/keys';

export const HistoryEarthBorn = ():JSX.Element => {
  const { t: translate } = useTranslation();
  
  return (
    <Box sx={ {
      pl: 2,
      color: 'action.active',
    } }
    >
      <Sparkles  />
      <Typography variant="body2">
        {translate(STRING_KEYS.HISTORY_EARTH_TITLE)}
      </Typography>
      <Typography variant="caption">
        
        {translate(STRING_KEYS.HISTORY_EARTH_TEXT)}
      </Typography>
    </Box>
  );
};
